// Port of api/fuel/app/classes/filter/search/games/filters/query/game/firstpublished.php
// Note: PHP uses $filter['year'] not $filter['firstyear']. Both published.php and
// firstpublished.php fire on the same key. This is a redundant filter in PHP.
export default {
	name: 'game.firstpublished',
	priority: 21,
	require: function(config, filter) {
		return filter.year.from !== 1970 || filter.year.to !== 2030
	},
	run: function(config, filter, data, query) {
		query.where('g.game_published', '>=', filter.year.from)
		query.where('g.game_published', '<=', filter.year.to)
	}
}
